<table mat-table  class="table table-hover"
 matSort="contactSort" [dataSource]="dataSource"
 infiniteScroll
 [infiniteScrollDistance]="2"
 [infiniteScrollThrottle]="20"
 [infiniteScrollContainer]="tablePosition"
 [fromRoot]="true"
  [trackBy]="trackByPosition"
 (scrolled)="onTableScroll()">
  <ng-container matColumnDef="positionName">
    <th mat-header-cell mat-sort-header *matHeaderCellDef class="w-15-rem">Name</th>
    <td mat-cell *matCellDef="let element">{{ element.positionName }} </td>
  </ng-container>
  <ng-container matColumnDef="actions">
    <th mat-header-cell
        *matHeaderCellDef
        class="w-15-rem"
        style="text-align: right">
      Action
    </th>
    <td mat-cell *matCellDef="let element" style="text-align: right">
      <a style="width:32px"
         class="btn btn-outline-primary btn-sm"
         (click)="EditPosition(element)"
         title="Edit position">
        <i style="font-size: 16px;margin-top: 1px;margin-left: -1px;" class="fa fa-edit"></i>
      </a>
      <span class="divider" style="padding-right:5px"></span>
      <a href="javascript:void(0)" class="btn btn-outline-primary btn-sm"
         (click)="DeletePosition(element)"
         title="Delete Position">
        <i class="fa fa-trash"></i>
      </a>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns$.value;sticky: true"></tr>
  <tr mat-row
      *matRowDef="
       let row;
       columns: displayedColumns$.value;
       let saleIndex = index
     "
      class="border-start-0 border-end-0 pointer pt-2 tr-fs-13px"></tr>
</table>
